import { getRequest } from '@/core';
import { cargoCarrierTypes } from '@/requests';

export async function getCargoCarrierTypesRequest() {
	let url = cargoCarrierTypes.getPath();
	try {
		return await getRequest(url);

	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}